import { motion } from "framer-motion";
import { Building2, TrendingUp, Clock, ArrowUpRight } from "lucide-react";

const EXCHANGES = [
  { name: "Redwood Logistics Center", status: "Identification", tone: "bg-blue-50 text-blue-600", pct: 38 },
  { name: "Bayfront Multifamily Tower", status: "In escrow", tone: "bg-amber-50 text-amber-600", pct: 64 },
  { name: "Stonebridge Retail Portfolio", status: "Closing", tone: "bg-green-50 text-green-600", pct: 92 },
];

const BARS = [40, 55, 48, 70, 62, 85, 78, 96];

export function HeroPlatformMockup() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
      className="relative w-full max-w-md mx-auto lg:max-w-none"
      data-testid="hero-platform-mockup"
    >
      {/* glow */}
      <div className="absolute -inset-6 bg-ally-pink/20 blur-3xl rounded-full opacity-40" aria-hidden />
      <motion.div
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        className="relative bg-white rounded-[22px] shadow-2xl shadow-black/40 border border-black/5 overflow-hidden"
      >
        {/* browser chrome */}
        <div className="flex items-center gap-2 px-4 py-3 bg-[#F4F4F5] border-b border-black/5">
          <span className="w-3 h-3 rounded-full bg-[#FF5F57]" />
          <span className="w-3 h-3 rounded-full bg-[#FEBC2E]" />
          <span className="w-3 h-3 rounded-full bg-[#28C840]" />
          <div className="ml-3 flex-1 max-w-[220px] bg-white border border-black/5 rounded-md text-[11px] text-ally-slate px-3 py-1 truncate">
            app.deferally.com/command-center
          </div>
        </div>

        {/* app body */}
        <div className="p-4 sm:p-5 bg-[#FBFBFC]">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-[11px] uppercase tracking-wider font-bold text-ally-pink">Command center</div>
              <div className="font-display text-base sm:text-lg font-bold text-ally-ink">Good morning, Dana</div>
            </div>
            <div className="w-8 h-8 rounded-full bg-ally-ink text-white text-xs font-bold flex items-center justify-center shrink-0">DC</div>
          </div>

          {/* KPI cards */}
          <div className="grid grid-cols-3 gap-2 sm:gap-3 mt-4">
            {[
              { icon: Building2, label: "Active exchanges", value: "24", accent: "text-ally-pink" },
              { icon: TrendingUp, label: "Funds in escrow", value: "$186M", accent: "text-green-600" },
              { icon: Clock, label: "Deadlines this wk", value: "7", accent: "text-amber-600" },
            ].map((k) => (
              <div key={k.label} className="bg-white border border-black/5 rounded-xl p-2.5 sm:p-3">
                <k.icon size={15} className={k.accent} />
                <div className="font-display text-base sm:text-lg font-black text-ally-ink mt-1.5 leading-none">{k.value}</div>
                <div className="text-[10px] text-ally-slate mt-1 leading-tight">{k.label}</div>
              </div>
            ))}
          </div>

          {/* chart card */}
          <div className="bg-white border border-black/5 rounded-xl p-3 mt-3">
            <div className="flex items-center justify-between">
              <div className="text-[11px] font-bold text-ally-ink">Exchange volume</div>
              <div className="text-[10px] font-bold text-green-600 flex items-center gap-0.5"><ArrowUpRight size={11} /> 12.4%</div>
            </div>
            <div className="flex items-end gap-1.5 h-14 mt-2">
              {BARS.map((h, i) => (
                <div key={i} className="flex-1 rounded-t-sm bg-gradient-to-t from-ally-pink/40 to-ally-pink" style={{ height: `${h}%` }} />
              ))}
            </div>
          </div>

          {/* exchange list */}
          <div className="bg-white border border-black/5 rounded-xl mt-3 divide-y divide-black/5">
            {EXCHANGES.map((e) => (
              <div key={e.name} className="flex items-center gap-3 px-3 py-2.5">
                <div className="w-1.5 h-8 rounded-full bg-ally-pink/70" />
                <div className="min-w-0 flex-1">
                  <div className="text-xs font-bold text-ally-ink truncate">{e.name}</div>
                  <div className="h-1.5 bg-black/5 rounded-full mt-1.5 overflow-hidden">
                    <div className="h-full bg-ally-pink rounded-full" style={{ width: `${e.pct}%` }} />
                  </div>
                </div>
                <span className={`text-[10px] font-bold rounded-full px-2 py-0.5 shrink-0 ${e.tone}`}>{e.status}</span>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
